import { useState, useEffect, useCallback } from 'react'
import useUserClient from '../../clients/UserClient/useUserClient'
import useSecurity from '../../security/useSecurity'

const useTomadorSelection = ({ documentTypeSize, enabled = true } = {}) => {
  const userClient = useUserClient()
  const { getEmail } = useSecurity()

  const [hasNoneClient, setHasNoneClient] = useState(false)
  const [hasUniqueClient, setHasUniqueClient] = useState(true)
  const [policiesHolder, setPoliciesHolder] = useState([{}])
  const [policyHolderOptions, setPolicyHolderOptions] = useState([''])

  const formatClients = useCallback((clientsUser) => clientsUser.map(({ name, cpfcnpj }) => ({
    id: cpfcnpj,
    text: `${cpfcnpj} ${name}`,
  })), [])

  useEffect(() => {
    if (!enabled) {
      setHasNoneClient(false)
      setHasUniqueClient(true)
      setPoliciesHolder([{}])
      setPolicyHolderOptions([''])
      return
    }

    userClient().getClientByUserLogged(true).then((response) => {
      const filterNotLead = response?.data?.filter((item) => item?.lead === false)

      const filteredByDocType = documentTypeSize
        ? filterNotLead?.filter(
          ({ cpfcnpj }) => cpfcnpj?.replace(/[.\-/\s]/g, '')?.length === documentTypeSize,
        )
        : filterNotLead

      const clientsData = formatClients(filteredByDocType)

      setHasNoneClient(clientsData.length === 0)
      setPoliciesHolder(clientsData)
      setPolicyHolderOptions(clientsData.map(({ text }) => text))
      setHasUniqueClient(clientsData.length === 1)

      if (clientsData.length === 1) {
        //
      }
    })
  }, [getEmail, userClient, formatClients, documentTypeSize, enabled])

  const findByText = useCallback(
    (text) => policiesHolder.find((item) => item?.text === text),
    [policiesHolder],
  )

  const findFirst = useCallback(() => (
    policiesHolder.length === 1 ? policiesHolder[0] : undefined
  ), [policiesHolder])

  return {
    hasNoneClient,
    hasUniqueClient,
    policiesHolder,
    policyHolderOptions,
    findByText,
    findFirst,
  }
}

export default useTomadorSelection
